export const pendingSelector = state => state.pending
